import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";

const Header = ({tittle, subTittle}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return( <Box mb={"30px"} ml={"15px"}>
        <Typography
            variant="h3"
            color={colors.dark[400]}
            fontWeight={"bold"}
            sx={{mb: "5px"}}
        >{tittle}</Typography>
        <Typography variant="h5" color={colors.blue[400]}>{subTittle}</Typography>
    </Box>)
}

export default Header;